module.exports = __webpack_public_path__ + "img/events.0e36ce1c.svg";